import { render, staticRenderFns } from "./LocaleSettings.vue?vue&type=template&id=37b6d4d8&scoped=true&"
import script from "./LocaleSettings.vue?vue&type=script&lang=js&"
export * from "./LocaleSettings.vue?vue&type=script&lang=js&"
import style0 from "./LocaleSettings.vue?vue&type=style&index=0&id=37b6d4d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b6d4d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VTooltip})
